import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { Status } from '@vision/ui/enums';
import { ContentCategory } from '@vision/ui/interfaces';
import { ContentCategoriesService } from '@vision/ui/services';

function getContentCategoriesStatusActive(list: ContentCategory[]): string[] {
  return list.filter((item) => item.status === Status.ACTIVE).map((item) => item.id);
}

export interface ContentCategoriesStateType {
  contentCategories: ContentCategory[];
  contentCategoriesTreeCheckedState: string[];
}

const initialState: ContentCategoriesStateType = {
  contentCategories: [],
  contentCategoriesTreeCheckedState: [],
};

export const ContentCategoriesState = createSlice({
  name: 'ContentCategoriesState',
  initialState,
  reducers: {
    setContentCategoriesTree: (state) => {
      state.contentCategoriesTreeCheckedState = getContentCategoriesStatusActive(state.contentCategories);
    },
    setContentCategoriesTreeCheckedState: (state, action: PayloadAction<string[]>) => {
      state.contentCategoriesTreeCheckedState = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder.addMatcher(ContentCategoriesService.endpoints.getContentCategories.matchFulfilled, (state, { payload }) => {
      state.contentCategories = payload;
    });

    // If there is a performance issue here, we can improve the lookup time by using a Map or Object.
    builder.addMatcher(
      ContentCategoriesService.endpoints.updateContentCategory.matchFulfilled,
      (state, { payload }) => {
        const index = state.contentCategories.findIndex((item) => item.id === payload.id);
        if (index !== -1) {
          state.contentCategories[index] = payload;
        }
      },
    );
  },
});

export const { setContentCategoriesTree, setContentCategoriesTreeCheckedState } = ContentCategoriesState.actions;
